<div class="wiki-group-dialog__container">
  <h2>
    @if (groupHasId) {
      <mat-icon svgIcon="pencil-outline"></mat-icon>
      Edit Group
    } @else {
      <mat-icon svgIcon="plus"></mat-icon>
      Create Group
    }
  </h2>

  <oph-input-orange
    [control]="$any(groupFG.get('name'))"
    [inputStyle]="{height: '50px', fontSize: '16px'}"
    placeholder="Group name"
  ></oph-input-orange>

  <oph-dialog-footer
    [labels]="footerActionLabels()"
    [menuOptions]="menuOptions"
    [hideMenu]="!groupHasId"
    [loading]="isLoading"
    (cancel)="onCancel()"
    (save)="onSave()"
    (menuOption)="onMenuOption($event)"
  />
</div>
